import { defineStore } from 'pinia';

export const treeHistory = defineStore('treeCardapio', {
  state: () => ({
    history: [],  
    initDate: false,
    handleNode : {}
  }),
  actions: {    
    setTree(history : any) {
      this.history = history   
    },   
    setUpdate(init: boolean) {
      this.initDate = init
    },
    setNode(Node){
      this.handleNode = Node
    } 
  },
  getters: {
    getHitoryTree: (state) => state.history,
    getInitDate: (state) => state.initDate,
    getHandleNode: (state) => state.handleNode,
  },
});

